import { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import Link from 'components/link'
import { Droppable } from 'react-beautiful-dnd'
import { MenuItem } from 'react-bootstrap'
import { DropdownButton } from 'components/DropdownButton/DropdownButton'
import { ChevronDownIcon, ChevronUpIcon } from 'components/icons'
import { CategoryHeader } from 'registry/components/reg-item-category/reg-item-category'
import {
  EditableCategoryHeader,
  RegItemDraggable,
  DeleteCategoryModal,
} from 'registry/components/organize'

import { getRegistryCategories, getRegistryCategory } from 'registry/reducers'
import {
  moveCategorizedRegItemToNewCategory,
  updateCategory,
} from 'registry/actions/reg-items-actions'
import scrollToElement from 'scroll-to-element'
import { CategoryIcon } from 'registry/components/CategoryIcon'

import styles from './CategoryDroppable.styles.scss'

const CategoryMoveButton = ({ className, direction, onClick }) => (
  <Link className={className} onClick={onClick}>
    {direction == 'up' ? <ChevronUpIcon /> : <ChevronDownIcon />}
  </Link>
)

class CategoryDroppable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditingCategoryTitle: false,
      showDeleteCategoryModal: false,
    }
  }

  static contextTypes = {
    isMobile: PropTypes.bool,
  }

  handleCategoryMove = (direction) => {
    const { categoryAttrs, updateCategory, index } = this.props
    const newIndex = index - direction
    const el = `#categoryIndex-${newIndex}`

    categoryAttrs.position -= direction
    updateCategory(categoryAttrs).then(() =>
      scrollToElement(el, { align: 'top' })
    )
  }

  handleCategoryPrivacyChange = () => {
    const { categoryAttrs, updateCategory } = this.props

    categoryAttrs.isPrivate = !categoryAttrs.isPrivate
    updateCategory(categoryAttrs)
  }

  handleCategoryTitleUpdate = (title) => {
    const { categoryAttrs, updateCategory } = this.props

    categoryAttrs.title = title
    updateCategory(categoryAttrs)
    this.setState({ isEditingCategoryTitle: false })
  }

  render() {
    const {
      category,
      category: { regItems = [] },
      categories,
      categoryAttrs,
      categoryAttrs: { title, isPrivate, isDeletable, isEditable, description },
      index,
    } = this.props
    const { isEditingCategoryTitle, showDeleteCategoryModal } = this.state

    const categoryHeaderAddOn = (
      <Link onClick={() => this.setState({ isEditingCategoryTitle: true })}>
        <i className={classNames('fa fa-pencil medium mlm text-light')} />
      </Link>
    )

    return (
      <div className={styles.CategoryDroppable}>
        <Droppable droppableId={index.toString()}>
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              className="category mtl pbs"
              id={`categoryIndex-${index}`}
              ref={provided.innerRef}
            >
              <hr className="mbl" />
              <div className={styles.CategoryDroppable__container}>
                <CategoryIcon
                  categoryId={category.id}
                  className={styles.CategoryDroppable__icon}
                />
                {isEditingCategoryTitle ? (
                  <EditableCategoryHeader
                    handleCategoryTitleUpdate={this.handleCategoryTitleUpdate}
                    title={title}
                  />
                ) : (
                  <CategoryHeader
                    isContributorView
                    addOn={isEditable && categoryHeaderAddOn}
                    className="mvl"
                    isPrivate={isPrivate}
                    regItemCount={regItems.length}
                  >
                    <span
                      className="text-muted"
                      onClick={
                        isEditable
                          ? () =>
                              this.setState({ isEditingCategoryTitle: true })
                          : null
                      }
                    >
                      {title}
                    </span>
                  </CategoryHeader>
                )}
                <div className="flex center grow justify-end">
                  <CategoryMoveButton
                    className="phm hidden-xs"
                    direction="up"
                    onClick={() => this.handleCategoryMove(1)}
                  />
                  <CategoryMoveButton
                    className="phm hidden-xs"
                    direction="down"
                    onClick={() => this.handleCategoryMove(-1)}
                  />
                  <DropdownButton
                    noCaret
                    pullRight
                    bsStyle="light"
                    className="mhxs phm pvs"
                    id={`More options for ${title}`}
                    title={
                      <i
                        className={classNames(
                          'fa fa-ellipsis-h medium text-light mts'
                        )}
                      />
                    }
                  >
                    <MenuItem onClick={this.handleCategoryPrivacyChange}>
                      Make {isPrivate ? 'Public' : 'Private'}
                    </MenuItem>
                    <MenuItem divider className="visible-xs" />
                    <MenuItem
                      className="visible-xs"
                      onClick={() => this.handleCategoryMove(1, categoryAttrs)}
                    >
                      Move Up
                    </MenuItem>
                    <MenuItem
                      className="visible-xs"
                      onClick={() => this.handleCategoryMove(-1, categoryAttrs)}
                    >
                      Move Down
                    </MenuItem>
                    {isDeletable && (
                      <>
                        <MenuItem divider />
                        <MenuItem
                          onClick={() =>
                            this.setState({ showDeleteCategoryModal: true })
                          }
                        >
                          Delete
                        </MenuItem>
                      </>
                    )}
                  </DropdownButton>
                </div>
              </div>
              {description && (
                <div className="h7 mbl">
                  {description}
                  {isPrivate && <span> (visible only to you)</span>}
                </div>
              )}
              {regItems
                .sort((r1, r2) => r2.position - r1.position)
                .map((regItem, index) => (
                  <RegItemDraggable
                    categories={categories}
                    index={index}
                    regItem={regItem}
                  />
                ))}
              {showDeleteCategoryModal && (
                <DeleteCategoryModal
                  category={category}
                  show={showDeleteCategoryModal}
                  onHide={() =>
                    this.setState({ showDeleteCategoryModal: false })
                  }
                />
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  categories: getRegistryCategories(state),
  categoryAttrs: getRegistryCategory(state, ownProps.category.id),
})

const mapDispatchToProps = {
  moveCategorizedRegItemToNewCategory,
  updateCategory,
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryDroppable)
